export default __webpack_public_path__ + "static/media/txt_music.fab9eeed.svg";